import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { multilineEllipsis } from '../../../theme/styles/mixins';

const useStyles = makeStyles((theme: Theme) => ({
  multilineEllipsis: {
    ...multilineEllipsis(),
  },
  editCardInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  // Edit mode card wrapper
  editCard: {
    border: '1px solid var(--avatar-background-default)',
    borderRadius: theme.spacing(1.5),
    margin: theme.spacing(2, 0),
    position: 'relative',
    '&:hover': {
      backgroundColor: 'var(--background-color-dark)',
      borderRadius: theme.spacing(1),
    },
  },

  // Horizontal layout (tiles)
  containerHorizontal: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'var(--background-color-dark)',
      borderRadius: theme.spacing(1),
    },
  },
  contentWrapperHorizontal: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  thumbnailHorizontal: {
    width: theme.spacing(7.5),
    height: theme.spacing(5),
    borderRadius: theme.spacing(0.75),
    backgroundColor: 'var(--background-color)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    overflow: 'hidden',
  },
  infoWrapperHorizontal: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    overflow: 'hidden',
    minWidth: 0,
  },

  // Vertical card layout (story)
  containerVertical: {
    overflow: 'hidden',
  },
  thumbnailVertical: {
    borderRadius: theme.spacing(1.5),
    width: '100%',
    backgroundColor: 'var(--background-color)',
    cursor: 'pointer',
    border: '1px solid var(--avatar-background-default)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'box-shadow 0.2s',
    overflow: 'hidden',
    '&:hover': {
      boxShadow: 'var(--header-box-shadow)',
    },
  },
  infoWrapperVertical: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },

  infoRow: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },

  // Shared styles
  thumbnailImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  folderIcon: {
    color: 'var(--gray-color)',
    fontSize: theme.spacing(3),
  },
  folderIconLarge: {
    color: 'var(--text-secondary)',
    fontSize: theme.spacing(6),
  },
  folderIconSmall: {
    color: 'var(--text-secondary)',
    fontSize: theme.spacing(2),
  },
  name: {
    fontWeight: 'var(--font-weight-semibold)',
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
    color: 'var(--text-primary-dark)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  nameVertical: {
    fontWeight: 'var(--font-weight-semibold)',
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
    color: 'var(--text-primary-dark)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  itemCount: {
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(18),
    color: 'var(--gray-color)',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
